<template>
    <div class="amic_video_content font-responsive">
        <div class="avc_thumb" :style="'background-image:url('+getSrc()+');'">
            <button v-if="component_data.vid_id" @click="createVideo()" class="avc_play"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 54 54"><path fill="currentColor" d="M22,38.25,37,27,22,15.75ZM27,2A25,25,0,1,0,52,27,25.009,25.009,0,0,0,27,2Zm0,45A20,20,0,1,1,47,27,20.027,20.027,0,0,1,27,47Z"/></svg></button>
            <p></p>
        </div>
    </div>
</template>

<script>
export default {
  props: ['component_data'],
  data(){
    return {
        uid: '',
        opened: false     
    }
  },
  methods: {   
    getSrc(){
        return this.component_data.thumb && this.component_data.thumb.src ? this.component_data.thumb.src : ''
    },   
    createVideo() {
        // dodaje globalną funkcję pozwalającą na dostęp do metod w komponencie
        window['vid_close_'+this.uid] = ()=>{
            this.destroyVideo()
            delete window['vid_close_'+this.uid]
        }

        var markup = [
            '<div id="vid_window_'+this.uid+'" v-if="opened" class="avc_page_overlay" onclick="vid_close_'+this.uid+'()">',
            '    <button on="opened=false" onclick="vid_close_'+this.uid+'()" class="avc_close">',
            '        <svg width="1em" height="1em" viewBox="0 0 64 64">',
            '            <path id="backdrop" d="M32,26.104l26.104,-26.104l5.896,5.896l-26.104,26.104l26.104,26.104l-5.896,5.896l-26.104,-26.104l-26.104,26.104l-5.896,-5.896l26.104,-26.104l-26.104,-26.104l5.896,-5.896l26.104,26.104Z"></path>',
            '            <path d="M31.983,28.447l26.087,-26.087l3.57,3.57l-26.087,26.087l26.087,26.087l-3.536,3.536l-26.087,-26.087l-26.087,26.087l-3.57,-3.57l26.087,-26.087l-26.087,-26.087l3.536,-3.536l26.087,26.087Z" style="fill:#fff;"></path>',
            '        </svg>',
            '    </button>',
            '    <div class="avc_video_wrapper">',
            '        <div class="avc_video">',
            '            <iframe src="https://www.youtube.com/embed/'+this.component_data.vid_id+'?autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>',
            '        </div>',
            '    </div>',
            '</div>'
        ].join('\n');

        document.getElementById('last-container').innerHTML = markup
        this.fireGTMIfExists()
    },
    destroyVideo() {
        let container = document.getElementById('last-container')
        let video = document.getElementById('vid_window_'+this.uid)
        container.removeChild(video)
    },
    fireGTMIfExists() {
        if (this.component_data.GTM) {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                'event': this.component_data.GTM.event,
                'video': this.component_data.GTM.video
            });
        }
    }
  },
  mounted(){
    this.uid = Math.random().toString(36).substr(2, 5);


  }
}
</script>

<style>
.amic_video_content {
    width: 100%;
    height: 100%;
    position: relative;
}

.avc_thumb {
    width: 100%;
    height: 100%;
    position: relative;
    background-position: center;
    background-size: cover;
}

.avc_play {
    height:100%;
    width:100%;
    display:flex;
    justify-content:center;
    align-items:center;
    border:none;
    background: radial-gradient(circle, rgba(0,0,0,.7), rgba(0,0,0,0));
    outline:none;
    cursor:pointer;
    color:white;
    text-align:center;
    transition-duration: .6s;
    opacity: .6;
}
.avc_play:hover {
    opacity: 1;
}
.avc_play svg {
    display: block;
    width: 5em;
    height: 5em;
}

</style>

<style>
.avc_page_overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1900;
    background-color: rgba(31, 31, 31, 0.541);
    display: flex;
    justify-content: center;
}

/*======*/

.avc_close {
    position: fixed;
    top: 40px;
    right: 40px;
    z-index: 2000;
    background: transparent;
    color: white;
    border: transparent;
    font-size: 34px;
    cursor: pointer;
}

/*======*/

.avc_video_wrapper {
    width: 90%;
    max-width: 177vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

@media (min-aspect-ratio: 1/1) {
    .avc_video_wrapper {
        width: 70%;
    }
}

.avc_video {
    position: relative;
    width: 100%;
	padding-bottom: 56.25%; /* 16:9 */
	height: 0;
}

iframe {
    position: absolute;
	top: 0;
	left: 0;
    height: 100%;
    width: 100%;
    border: 0;

    z-index: 1900;
    max-height: 100vh;
    max-width: 100vw;
}

/*======*/

.close-video #backdrop {
    fill: #d9d9d9;
}
.close-video:hover #backdrop {
    fill: #e70b28;
}

</style>
